export default import.meta.ROLLUP_FILE_URL_DH9aFNLU;